// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"157114e2","167":"7ece9aca","273":"f035fe60","436":"9eae05f2","583":"090ae300","858":"c729de59","881":"afa186e3","970":"8aecb0c3"}[chunkId] + ".chunk.css";
};